module.exports = __webpack_public_path__ + "img/ic_zs.ff11f680.png";